module.exports = __webpack_public_path__ + "static/media/po-Reman_Minor_Injectior_Xparent.d8bb55ac.png";